import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";

Chart.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({ title, chartData }) => {
  // Data preparation based on chart type
  let labels = [];
  let dataValues = [];

  if (title === "Providers") {
    labels = ["Compliant", "Non-compliant", "Partial"];
    dataValues = [
      Number(chartData?.compliant || 0),
      Number(chartData?.non_compliant || 0),
      Number(chartData?.partial || 0),
    ];
  } else if (title === "Workers") {
    labels = ["Compliant", "Non-compliant","Partial"];
    dataValues = [
      Number(chartData?.compliant || 0),
      Number(chartData?.non_compliant || 0),
      Number(chartData?.partial || 0),
    ];
  } else if (title === "Clients") {
    labels = ["Active"];
    dataValues = [
      Number(chartData?.active_clients || 0),
    ];
  }

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Status",
        data: dataValues,
        backgroundColor: [
          "#86E5B2", // Color for Compliant
          "#FDA29B", // Color for Non-compliant
          "#D0D5DD", // Color for Invited/Partial
          "#F79009"  // Additional color if needed
        ],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hide default legend
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const total = context.dataset.data.reduce((a, b) => Number(a) + Number(b), 0);
            const percentage = ((context.raw / total) * 100).toFixed(2);
            return `${context.label}: ${context.raw} (${percentage}%)`;
          },
        },
      },
    },
    cutout: "70%", // Makes it a doughnut chart
  };

  // Calculate total for center text
  const totalItems = dataValues.reduce((a, b) => Number(a) + Number(b), 0);

  return (
    <div className="flex items-center gap-5 cstm-wrap">
      <div className="relative w-52 h-52">
        <Doughnut data={data} options={options} />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
          <h3 className="text-xl font-bold">{totalItems}</h3>
          <p className="text-sm">{title}</p>
        </div>
      </div>
      
      <div>
        <ul className="list-none p-0">
          {labels.map((label, index) => (
            <li key={index} className="flex items-start mb-3 !w-40">
              <span
                className="inline-block w-4 h-4 rounded-full mr-3"
                style={{ backgroundColor: data.datasets[0].backgroundColor[index] }}
              ></span>
              <div className="flex flex-col">
                <span className="font-medium">{label}</span>
                <span className="text-gray-600">{dataValues[index]}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DoughnutChart;